export function formatInt(value) {
  return parseInt(value, 10).toLocaleString();
}

export function formatNumber(value) {
  return parseInt(value, 10).toLocaleString();
}
